/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';
import type { Individu } from '@/types';

/**
 * Hook pour créer un individu avec tous les champs formatés
 */
const useCreateIndividu = () => {
  const [loading, setLoading] = React.useState(false);

  const createIndividu = React.useCallback(
    (
      individu: Partial<Individu>,
      isBrouillon = false,
      identifiantTeledossier?: string,
    ) => {
      setLoading(true);

      // Exclure les données Hubee volumineuses qui ne doivent pas être envoyées au serveur
      const {
        teledossierData,
        setTeledossierData,
        errors,
        setErrors,
        onChange,
        isBrouillonFromForm,
        ...individuData
      } = individu as any;

      return request
        .post('/api/administres/recensement-citoyen/individus', {
          ...individuData,
          ...(_.isNil(individuData?.moisNaissance) && { moisNaissance: 1 }),
          ...(_.isNil(individuData?.jourNaissance) && { jourNaissance: 1 }),
          ...(!_.isNil(individuData?.diplome) && {
            identifiantDiplome: individuData?.diplome?.identifiant,
          }),
          parent1: !_.isEmpty(individuData?.parent1)
            ? {
                ...individuData?.parent1,
                ...(_.isNil(individuData?.parent1?.moisNaissance) && {
                  moisNaissance: 1,
                }),
                ...(_.isNil(individuData?.parent1?.jourNaissance) && {
                  jourNaissance: 1,
                }),
              }
            : {},
          parent2: !_.isEmpty(individuData?.parent2)
            ? {
                ...individuData?.parent2,
                ...(_.isNil(individuData?.parent2?.moisNaissance) && {
                  moisNaissance: 1,
                }),
                ...(_.isNil(individuData?.parent2?.jourNaissance) && {
                  jourNaissance: 1,
                }),
              }
            : {},
          ...(!_.isNil(individuData?.situationScolaire) && {
            identifiantSituationScolaire:
              individuData?.situationScolaire?.identifiant,
          }),
          ...(!_.isNil(individuData?.specialite) && {
            identifiantSpecialite: individuData?.specialite?.identifiant,
          }),
          ...(!_.isNil(individuData?.profession) && {
            identifiantProfession: individuData?.profession?.identifiant,
          }),
          nombreEnfants: _.toNumber(individuData?.nombreEnfants),
          nombreFreresSoeurs: _.toNumber(individuData?.nombreFreresSoeurs),
          prenomsComplementaires: individuData?.prenomsComplementaires
            ?.split(',')
            .map((prenom) => prenom.trim())
            .filter((prenom) => prenom)
            .join(', '),
          isBrouillon,
          ...(identifiantTeledossier && { identifiantTeledossier }),
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [],
  );

  return { createIndividu, loading };
};

export default useCreateIndividu;
